import hoistNonReactStatistics from 'hoist-non-react-statics';
import React from 'react';
import type { OptionTypeBase } from 'react-select';
import { default as SelectBase } from 'react-select/creatable';
import InputSkeleton from '../components/input-skeleton';
import AbstractSelect from './abstract-select';
import { CreatableSelectProps } from './select.types';

const SelectCreatable = <
  OptionType extends OptionTypeBase = { label: React.ReactNode; value: any },
  IsMulti extends boolean = false,
>(
  props: CreatableSelectProps<OptionType, IsMulti>,
  ref?: React.Ref<SelectBase<OptionType, IsMulti>>,
) => <AbstractSelect ref={ref} {...props} Component={SelectBase} />;

SelectCreatable.Prefix = InputSkeleton.Prefix;
SelectCreatable.Icon = InputSkeleton.Icon;

export default hoistNonReactStatistics(
  React.forwardRef(SelectCreatable),
  SelectCreatable,
) as typeof SelectCreatable;
